import BaseEnumType from "../../common/base-enum-type";

const ClockType = Object.freeze({
    DESC: new BaseEnumType("DESC", "Descending"),
    ASC: new BaseEnumType("ASC", "Ascending")
});

export default ClockType;
